import router from "@/router/router"
import axios from "axios"

const $clientApi = axios.create({
  baseURL: import.meta.env.VITE_TIPS_URL
})

$clientApi.interceptors.request.use(config => {
  const token = localStorage.getItem('client_token')

  if (token) {
    config.headers['X-Menu-Access-Token'] = 'Bearer ' + token
  }
  return config
})

$clientApi.interceptors.response.use(
  response => response,
  error => {
    const status = error.response?.status
    // Маршрута qr-menu-auth сейчас нет в routes.ts — без проверки push бросает "No match"
    if ((status === 401 || status === 403) && router.hasRoute('qr-menu-auth')) {
      router.push({ name: 'qr-menu-auth' })
    }

    return Promise.reject(error)
  }
)

export default $clientApi
